import { Basket, DeliveryMethods } from '~/api/modules/basket/types'
import { BasketState } from '~/store/basket/basket.types'

export function wordDeclension(words: string[], itemCount: number): string {
  const number = itemCount
  const word =
    words[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? number % 10 : 5]
    ]
  return `${number} ${word}`
}

export function getMappedBasket(
  basket: Partial<Basket>,
  state: BasketState,
  features?: { isFetch?: boolean; disableMapOfProposition?: boolean },
) {
  const basketState = {
    totalPrice: basket.total_price || 0,
    totalAmount: basket.total_amount || 0,
    amountToPay: basket.amount_to_pay || 0,
    itemsCount: basket.items_count || 0,
    items: basket.items || [],
    maxNumberOfPersons: basket.max_number_of_persons || 0,
    persons: {
      errorMessage: basket.persons?.error_message || '',
      helpMessage: basket.persons?.help_message || '',
      message: basket.persons?.message || '',
      maxNumber: basket.persons?.max_number || 0,
      number: basket.persons?.number || 0,
    },
    promocode: {
      discountAmount: basket.promo_code?.discount_amount || 0,
      title: basket.promo_code?.title || '',
      valid: basket.promo_code?.valid ?? true,
      error: basket.promo_code?.error || '',
      type: basket.promo_code?.type || '',
      value: basket.promo_code?.value || '',
    },
    additives: basket.additives || [],
    gifts: basket.gifts || [],
    delivery: {
      order_address: basket.delivery?.order_address,
      cost: basket.delivery?.cost || null,
      method: basket.delivery?.method || DeliveryMethods.COURIER,
      addresses: {
        [DeliveryMethods.COURIER]:
          basket.delivery?.method === DeliveryMethods.COURIER
            ? basket.delivery?.address_id
            : '',
        [DeliveryMethods.HALL]:
          basket.delivery?.method === DeliveryMethods.HALL
            ? basket.delivery?.point_id
            : '',
        [DeliveryMethods.PICKUP]:
          basket.delivery?.method === DeliveryMethods.PICKUP
            ? basket.delivery?.point_id
            : '',
      },
    },
    bonuses: {
      toAccrueAmount: basket.bonuses?.to_accrue_amount || 0,
      errorMessage: basket.bonuses?.error_message || '',
      maxSpendAmount: basket.bonuses?.max_spend_amount || 0,
      message: basket.bonuses?.message || '',
      toSpendAmount: basket.bonuses?.to_spend_amount || 0,
      totalAmount: basket.bonuses?.total_amount || 0,
    },
    selectedPaymentMethod: state.data.selectedPaymentMethod,
    note: state.data.note,
    change: state.data.change,
    proposition: features?.disableMapOfProposition
      ? state.data.proposition
      : {
          timeToLive: basket.proposition?.time_to_live || 0,
          popupText: basket.proposition?.popup_text || '',
          items: basket.proposition?.items || [],
        },
    clientPacks: basket.client_packs || [],
    doNotCallMeBack: features?.isFetch
      ? basket.do_not_call_me_back
      : state.data.doNotCallMeBack, // По дефолту нужно перезвонить
    isExtra: basket.is_extra || false,
  }

  if (basket.items_count === 0) {
    basketState.selectedPaymentMethod = null
    basketState.note = ''
  }

  return basketState
}
